import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PatientCareCenterButton, FotoButton, RTMButton, PatientDot } from '_components'
import { patientActions } from '_actions';
import styles from './ScheduleRow.module.css'
import { getApptStatusIndicator } from '_helpers';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { faX, faMarsStroke, faVenus, faTriangleExclamation, faScissors, faDesktop } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


class TherapistDashboardScheduleRow extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            seconds: 0
        };
    }

    tick() {
        this.setState(state => ({
            seconds: state.seconds + 10
        }));
    }

    componentDidMount() {
        if (this.props.appt?.ADTASID === 1) {
            this.interval = setInterval(() => this.tick(), 10000);
        }
    }

    componentWillUnmount() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    rowClicked(e) {
        if (!e.isDefaultPrevented()) {
            if (this.props.appt?.NSNO === 1) {
                this.props.openPatient(this.props.appt?.PTNO);
            } else if (this.props.appt?.NSNO === 2) {
                this.props.openPatient(this.props.appt?.PTNO);
            } else if (this.props.appt?.NSNO === 3) {
                this.props.openPatient(this.props.appt?.PTNO);
            } else if (this.props.appt?.ADTASID === 1 &&
                new Date().getTime() > new Date(this.props.date).getTime() + this.props.appt?.APTSTART &&
                this.props.epnos.length === 1) {
                this.props.openPatientStartNote(this.props.appt?.PTNO, this.props.epnos[0], this.props.appt?.APTID, this.props.date, undefined);
            } else if (this.props.appt?.ADTASID === 2 && this.props.epnos.length === 1) {
                this.props.openPatientStartNote(this.props.appt?.PTNO, this.props.epnos[0], this.props.appt?.APTID, this.props.date, undefined);
            } else if (this.props.appt?.ADTASID === 4) {
                this.props.openPatient(this.props.appt?.PTNO);
            } else if (this.props.appt?.ADTASID === 5) {
                this.props.openPatient(this.props.appt?.PTNO);
            } else if (this.props.appt?.ADTASID === 6) {
                this.props.openPatient(this.props.appt?.PTNO);
            } else if (this.props.appt?.ADTASID === 7) {
                this.props.openPatient(this.props.appt?.PTNO);
            } else {
                this.props.openPatient(this.props.appt?.PTNO);
            }
        }
    }

    showContent() {
        document.getElementById('patient_content' + this.props.appt.APTID).style.opacity = '1';
    }

    hideContent() {
        document.getElementById('patient_content' + this.props.appt.APTID).style.opacity = '0';
    }

    renderContent() {
        let width = 160;
        let position = 'right';
        let leftPos = 200;

        return (
            <span id={'patient_content' + this.props.appt.APTID} className={styles.content_wrapper} style={{ width: width, left: leftPos }} >
                <div className={styles.inner_wrapper}>
                    <div className={styles.inner_content_wrapper}>
                        <b> {this.props.appt?.PTFNAME + ' ' + this.props.appt?.PTLNAME}</b><br />
                        <label>
                            {this.props.appt?.PhotoID &&
                                <FontAwesomeIcon icon={faCheck} transform="shrink-4" color="green" />
                            }
                            {!this.props.appt?.PhotoID &&
                                <FontAwesomeIcon icon={faX} transform="shrink-4" color="red" />
                            }  Photo ID
                        </label> <br />
                        <label>
                            {this.props.appt?.IntakeForm &&
                                <FontAwesomeIcon icon={faCheck} transform="shrink-4" color="green" />
                            }
                            {!this.props.appt?.IntakeForm &&
                                <FontAwesomeIcon icon={faX} transform="shrink-4" color="red" />
                            }  Intake Paperwork
                        </label> <br />
                        <label>
                            {this.props.appt?.FOTOIntake &&
                                <FontAwesomeIcon icon={faCheck} transform="shrink-4" color="green" />
                            }
                            {!this.props.appt?.FOTOIntake &&
                                <FontAwesomeIcon icon={faX} transform="shrink-4" color="red" />
                            }  FOTO
                        </label> <br />

                    </div>
                </div>
            </span>
        );
    }

    renderRTM() {
        if (this.props.appt?.eprtmenabled === null && this.props.appt?.eprtmactive === null) {
            return (<RTMButton size='smaller' color="redText" title="Not enabled and not activated" />);
        } else if (this.props.appt?.eprtmenabled === true && this.props.appt?.eprtmactive === null) {
            return (<RTMButton size='smaller' color="yellowText" title="Enabled but not activated" />);
        } else if (this.props.appt?.eprtmenabled === true && this.props.appt?.eprtmactive === true) {
            return (<RTMButton size='smaller' color="greenText" title="Enabled and activated" />);
        }
    }

    render() {

        return (
            <div className={this.props.appt?.ISPOCDUE || this.props.appt?.ISPROGRESSDUE || this.props.appt?.ISPROGRESSVISIT || this.props.appt?.AUTHSTATUS !== 1 ? styles.appt_wrapper_pn : this.props?.isOdd ? styles.appt_wrapper_odd : styles.appt_wrapper} onClick={e => this.rowClicked(e)}>
                <span className={styles.col1}>
                    {getApptStatusIndicator(this.props.appt?.NSNO, this.props.appt?.ADTASID, this.props?.date, this.props.appt?.APTSTART)}
                </span>
                <span className={styles.col2}>
                    <PatientCareCenterButton ptno={this.props.appt?.PTNO} size='smaller' preventDefault={true} />
                </span>
                <span className={styles.col3} title={this.props.appt?.APTSTARTTEXT + ' - ' + this.props.appt?.APTENDTEXT}>
                    {this.props.appt?.APTSTARTTEXT}
                </span>
                <span className={styles.col4}>
                    <PatientDot id={this.props.appt?.DOT} />
                    <span className={styles.patient_wrapper} onMouseOver={() => this.showContent()} onMouseOut={() => this.hideContent()}>
                        <label className={styles.patient_name + (this.props.appt?.ISFEDERAL ? ' ' + styles.italic : '') + (this.props.appt?.ISEVAL ? ' ' + styles.bold : '')} title={this.props.appt?.PTFNAME + ' ' + this.props.appt?.PTLNAME}>
                            {this.props.appt?.PTFNAME + ' ' + this.props.appt?.PTLNAME}
                        </label>
                    </span>
                    {this.renderContent()}
                </span>
                <span className={styles.col5} title={this.props.appt?.LCNAME}>
                    {this.props.appt?.LCNAME}
                </span>

                <span className={styles.col7}>
                    <div className={styles.buttonSection}>
                        {
                            this.props.appt?.scissorsBadge === 1
                            &&
                            <FontAwesomeIcon icon={faScissors} transform="shrink-4" color="black" title="Assistant Modifier" />
                        }
                    </div>
                    <div className={styles.buttonSection}>
                        {
                            this.props.appt?.FOTOBadge === 1
                            &&
                            <img alt='Foto' className={styles.badge} src='./images/foto.png' title={"FOTO - " + this.props.fotoText}></img>
                        }
                    </div>
                    <div className={styles.buttonSection}>
                        {
                            this.props.appt?.spanishBadge === 1
                            &&
                            <img alt='Spanish' className={styles.badge} src='./images/spanishflag.png' title="Spanish"></img>
                        }
                    </div>
                    <div className={styles.buttonSection}>
                        {
                            this.props.appt?.genderMaleBadge === 1
                            &&
                            <FontAwesomeIcon icon={faMarsStroke} transform="shrink-4" color="black" title="Male" />
                        }
                        {
                            this.props.appt?.genderFemaleBadge === 1
                            &&
                            <FontAwesomeIcon icon={faVenus} transform="shrink-4" color="black" title="Female" />
                        }
                    </div>
                    <div className={styles.buttonSection}>
                        {
                            this.props.appt?.attentionBadge === 1
                            &&
                            <FontAwesomeIcon icon={faTriangleExclamation} transform="shrink-4" color="#d9bd66" title="Attention" />
                        }
                    </div>
                    <div className={styles.buttonSection}>
                        {
                            this.props.appt?.['1on1Badge'] === 1
                            &&
                            <img alt='1 on 1' className={styles.badge} src='./images/1on1.png' title="1 on 1"></img>
                        }
                    </div>
                    <div className={styles.buttonSection}>
                        {
                            this.props.appt?.VTTELEHEALTH === 1
                            &&
                            <FontAwesomeIcon icon={faDesktop} transform="shrink-4" color="#1cad09" title="TeleHealth" />
                        }
                    </div>
                    <div className={styles.buttonSection}>
                        {this.props.isRTMEligible && this.renderRTM()}
                    </div>


                </span>
            </div>
        );

    }
}


function mapDispatchToProps(dispatch) {
    return {
        openPatient: bindActionCreators(patientActions.open, dispatch),
        openPatientStartNote: bindActionCreators(patientActions.openStartNote, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let appt = state.entities.dashboard.schedule[ownprops.id];
    let fotoThresholds = state.entities.masterData?.PTMASTERTHRESHOLDS[
        Object.keys(state.entities.masterData.PTMASTERTHRESHOLDS)
            .find(key => state.entities.masterData.PTMASTERTHRESHOLDS[key].WTNAME === 'FOTO_SURVEY_VISITS')];
    let date = state.ui.dashboard.date;
    let epnos = Object.keys(state.entities.dashboard.scheduleAdmissions)
        .filter(x => state.entities.dashboard.scheduleAdmissions[x]?.APTID === appt?.APTID)
        .map(x => state.entities.dashboard.scheduleAdmissions[x].AEXEPNO);
    let fotoText = !appt?.ISFOTOCLAIMED ?
        'The patient\'s admission has not been associated with a FOTO episode.  Visit the FOTO website to check the status of the patient.'
        : 'It has been ' + appt?.FOTOVISITS + ' visits since the patient has completed a FOTO survey.';

    let isRTMEligible = appt?.ISRTMELIGIBLE === true;



    return {
        appt,
        fotoThresholds,
        date,
        epnos,
        fotoText,
        isRTMEligible
    };
}

const connectedTherapistDashboardScheduleRow = connect(mapStateToProps, mapDispatchToProps)(TherapistDashboardScheduleRow);
export { connectedTherapistDashboardScheduleRow as TherapistDashboardScheduleRow };

